import { Back, CloseLine } from '@pyt/icons'
import { Icon, Text } from '@pyt/micros'
import React from 'react'
import styled from 'styled-components'

const HeaderContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 16px;
	min-height: 64px;
	background-color: #fff;
	box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.06);
	color: #333;
	text-align: center;
	font-size: 20px;
	z-index: 1;
`

// placeholder for the button item to avoid alignment issues
const dummyButton = <i />

/**
 * Modal Header used in mobile modals - like GCM
 * @param {string} title - text for modal title
 * @param {boolean} showActionButtons - toggle left/right buttons (false by default)
 * @param {string} leftIcon - icon class for left side button
 * @param {string} rightIcon - icon class for right side button
 * @param {function} onLeftClick - callback method for left side button
 * @param {function} onRightClick - callback method for right side button
 */
const ModalHeader = ({
	title,
	isPDG,
	onLeftClick,
	onRightClick,
	isMobile = false,
}) => {
	return (
		<HeaderContainer isPDG={isPDG}>
			{/* <Space gutter="auto" borderBottomWidth={1} borderBottomColor="grey03" padding={16}>
      </Space> */}
			{typeof onLeftClick === 'function' ? (
				<Icon icon={Back} onPress={onLeftClick} />
			) : (
				dummyButton
			)}
			<Text
				fontSize={isMobile ? 16 : 20}
				fontWeight={isMobile ? 600 : 400}
				fontFamily="Source Sans Pro"
			>
				{title}
			</Text>
			{typeof onRightClick === 'function' ? (
				<Icon icon={CloseLine} onPress={onRightClick} />
			) : (
				dummyButton
			)}
		</HeaderContainer>
	)
}

export default ModalHeader
